import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { getProductLabel } from './../../Services/productLabels';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },

  label: {
    color: '#002857',
    fontFamily: 'Roboto, var(--font-sans)',
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0',
    fontWeight: 400,
    flex: '0 0 auto',
    marginTop: 4, // optically centers the 24px line with the 32px pills
  },

  strip: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },

  pill: {
    height: 32,
    padding: '0 14px',
    borderRadius: 16,
    border: '1px solid #C0D2E5',
    background: '#F1F9FF',
    color: '#181D27',
    fontFamily: 'var(--font-sans)',
    fontSize: 14,
    lineHeight: '20px',
    cursor: 'pointer',
    transition: 'background .15s ease, color .15s ease, border-color .15s ease',
    '&:hover': { background: '#E3F2FF' },
    '&:focus-visible': { outline: '2px solid rgba(12,112,232,.6)', outlineOffset: 2 },
  },
  pillActive: {
    background: '#0C70E8',
    borderColor: '#0C70E8',
    color: '#FFFFFF',
    fontWeight: 600,
    '&:hover': { background: '#0C70E8' },
  },
});

// Chips are the distinct products from the unfiltered listing. `products` and
// `active` hold the raw backend value ('' = All); labels are display-only.
const ProductSelection = (props) => {
  const { classes, onSelected, products, active } = props;
  const chips = [{ value: '', label: 'All' }].concat(
    (products || []).map((p) => ({ value: p, label: getProductLabel(p) }))
  );

  return (
    <div className={`${classes.root} product-select`}>
      <span className={`${classes.label} product-span`}>Filter for</span>
      <div className={classes.strip} role="group" aria-label="Filter for">
        {chips.map((c) => (
          <button
            key={c.value || 'all'}
            type="button"
            aria-pressed={active === c.value}
            className={`${classes.pill} ${active === c.value ? classes.pillActive : ''}`}
            onClick={() => onSelected && onSelected(c.value)}
          >
            {c.label}
          </button>
        ))}
      </div>
    </div>
  );
};

ProductSelection.defaultProps = { products: [], active: '' };

export default React.memo(withStyles(styles)(ProductSelection));
